import React from 'react';
import { Button, Tab, Nav } from 'react-bootstrap';

import { ReactComponent as WalletIcon } from '../../img/svg/Assets/WalletIcon.svg';
import { ReactComponent as CopyIcon } from '../../img/svg/Actions/Copy.svg';
import { ReactComponent as BagIcon } from '../../img/svg/Assets/bag.svg';
import { ReactComponent as TicketIcon } from '../../img/svg/Assets/Ticket.svg';
import { ReactComponent as LogoutIcon } from '../../img/svg/Actions/Logout.svg';
import { ReactComponent as Bookmark2Icon } from '../../img/svg/Assets/Bookmark.svg';
import { ReactComponent as Wallet2Icon } from '../../img/svg/Assets/Wallet.svg';

import { MainContext } from './../../contexts/MainContext';
import MyCrypto from './MyCrypto';
import MyBucks from './MyBucks';
import MyNFTs from './MyNFTs';
import MyAccessTokens from './MyAccessTokens';
import utils from '../../utils';
import { successMsg } from '../../config';
import AddFund from '../Modals/AddFund';
import DropDown from './DropDown';

import './index.scss';

class WalletSlide extends React.Component {
  static contextType = MainContext;
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      picture: props.picture,
      iframeLink: null,
      walletId: props.account
    };
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      picture: newProps.picture,
      walletId: newProps.account
    });
  }
  componentWillUnmount() {
    this.handleToggle('closeall');
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleToggle = (closeall) => {
    const mainContext = this.context;
    if (!mainContext.isCartSlideOpen) {
      mainContext.setCartSlide(!mainContext.isCartSlideOpen);
    }
    mainContext.setWalletSlide(!mainContext.isWalletSlideOpen);
    if (closeall) {
      mainContext.setWalletSlide(true);
      mainContext.setCartSlide(true);
    }
    this.props?.setOpen?.(false);
  };

  getTotalBalance() {
    let balance = 0;
    if (this.context.balance.totalUsd) {
      balance = Number(this.context.balance.totalUsd);
    }
    if (this.context.totalBucksValue) {
      balance = balance + Number(this.context.totalBucksValue);
    }
    return Math.floor((balance + Number.EPSILON) * 100) / 100;
  }
  handleOutsideClick = (e) => {
    if (e.target === document.getElementById('content-area')) {
      this.handleToggle('closeall');
    }
  };
  copyAlert = () => {
    if (this.props.account) {
      successMsg('Wallet Address Copied SuccessFully');
    }
  };
  render() {
    const mainContext = this.context;

    return (
      <>
        <Button
          onClick={() => this.handleToggle()}
          className="p-0 nav-link wallet-nav-item position-relative"
        >
          <WalletIcon />
        </Button>
        <div
          id="content-area"
          onClick={this.handleOutsideClick}
          className={`wallet-slide-right ${
            mainContext.isWalletSlideOpen ? 'wallet-none' : ''
          }`}
        >
          <div className="wallet-bg text-white">
            <div className="d-flex text-white align-items-center justify-content-between px-2 pt-2 test">
              <div className="wallet-heading d-flex ">
                <DropDown
                  picture={this.state.picture}
                  disconnect={() => this.props.disconnect()}
                />
              </div>
              {this.props.account ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    navigator.clipboard.writeText(this.props.account);
                    this.copyAlert();
                  }}
                >
                  {utils.getShortAccountId(this.props.account)}
                  &nbsp; <CopyIcon />
                </div>
              ) : (
                ''
              )}
            </div>
            <div className="total p-2 test">
              <div>Total balance</div>
              <div className="amount">
                $
                {mainContext.balance.usdcBalancePoly
                  ? mainContext.balance.usdcBalancePoly
                  : '0'}{' '}
                USD
              </div>
            </div>
            <AddFund />
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Tab.Content>
                <Tab.Pane className="tab-cont-scroll" eventKey="first">
                  <div>
                    <MyCrypto />
                  </div>
                </Tab.Pane>
                <Tab.Pane className="tab-cont-scroll" eventKey="second">
                  <div>
                    <MyBucks
                      totalBucksCount={mainContext.totalBucksCount || 0}
                      totalBucksValue={mainContext.totalBucksValue || 0}
                      closeDrawer={() => this.context.setWalletSlide(true)}
                    />
                  </div>
                </Tab.Pane>
                <Tab.Pane className="tab-cont-scroll" eventKey="third">
                  <div>
                    <MyNFTs
                      totalSnftCount={mainContext.totalSnftCount || 0}
                      totalSnftAmount={mainContext.totalSnftAmount || 0}
                      closeDrawer={() => this.context.setWalletSlide(true)}
                    />
                  </div>
                </Tab.Pane>
                <Tab.Pane className="tab-cont-scroll" eventKey="forth">
                  <div>
                    <MyAccessTokens
                      totalAccessNftCount={mainContext.totalAccessNftCount || 0}
                      closeDrawer={() => this.context.setWalletSlide(true)}
                    />
                  </div>
                </Tab.Pane>
              </Tab.Content>
              {/* FOOTER */}
              <div className="wallet-slide-footer">
                <Nav variant="pills" className="flex-column navbar-nav">
                  <Nav.Item>
                    <Nav.Link eventKey="first">
                      <Wallet2Icon className="me-3" />
                      My Crypto
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second">
                      <BagIcon className="me-3" />
                      My Bucks
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="third">
                      <Bookmark2Icon className="me-3" />
                      My Campaign Clubs
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="forth">
                      <TicketIcon className="me-3" />
                      My Access NFTs
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      onClick={() => {
                        this.props.disconnect();
                      }}
                    >
                      <LogoutIcon className="me-3" />
                      Logout
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </Tab.Container>
          </div>
        </div>
      </>
    );
  }
}

export default WalletSlide;
